<template>
  <div>
    <el-button v-if="showBack" type="primary" size="mini" @click="back">返回
    </el-button>
    <el-table :data="configList">
      <el-table-column label="状态" width="100px">
        <template v-slot="{ row }">
          <i v-if="row.passed" class="el-icon-success" style="color:#67C23A;"></i>
          <i v-else class="el-icon-error" style="color:#F56C6C;"></i>
        </template>
      </el-table-column>
      <el-table-column label="文件名称" prop="name">
      </el-table-column>
      <el-table-column label="路径" prop="oldLocation">
      </el-table-column>
      <el-table-column label="原版本号" prop="oldVersion">
      </el-table-column>
      <el-table-column label="新版本号" prop="newVersion">
      </el-table-column>
      <el-table-column label="操作" width="400px">
        <template v-slot="{ row, index }">
          <span v-if="row.isDir">
            <el-button type="primary" size="mini" @click="enter(row.oldLocation, true)">进入</el-button>
          </span>
          <span v-else>

            <el-button type="primary" size="mini" style="margin-right:10px;" @click="compare(row)">配置文件对比
            </el-button>
            <!--          <el-dropdown style="margin-right:10px;" trigger="click">-->
            <!--            <el-button type="primary" size="mini">查看</el-button>-->
            <!--            <el-dropdown-menu slot="dropdown">-->
            <!--              <el-dropdown-item>-->
            <!--                <el-button type="primary" size="mini" @click="configDetail(row, 'old')">原配置文件</el-button>-->
            <!--              </el-dropdown-item>-->
            <!--              <el-dropdown-item>-->
            <!--                <el-button type="primary" size="mini" @click="configDetail(row, 'new')">新配置文件</el-button>-->
            <!--              </el-dropdown-item>-->
            <!--            </el-dropdown-menu>-->
            <!--          </el-dropdown>-->
            <span v-if="!oldData.docker">
              <el-dropdown style="margin-right:10px;" trigger="click">
                <el-button type="primary" size="mini">下载</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>

                    <el-button type="primary" size="mini" @click='downloadConfig(row, "old")'>原配置文件</el-button>

                  </el-dropdown-item>
                  <el-dropdown-item>

                    <el-button type="primary" size="mini" @click='downloadConfig(row, "new")'>新配置文件</el-button>

                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-upload v-if="row.oldVersion != row.newVersion" style="display: inline-block;margin-right: 10px;"
                ref="upload" :on-success="handleSuccess" :on-error="handleError"
                :action="baseUrl3 + 'config/upload/ins/config'" :show-file-list="false" name="filePart" :data="{
                  configName: row.name.trim(),
                  location: row.newLocation+'',
                  instanceId: newData.id,
                  moduleName: newData.moduleType,
                  moduleVersion: newData.moduleVersion
                }">
                <el-button size="mini" type="primary">上传</el-button>
              </el-upload>
              <el-button v-if="(!row.name.toLowerCase().startsWith('exchange.xml')
                && !row.name.toLowerCase().startsWith('servicehelper.yml')) ||
                row.name.toLowerCase().startsWith('service-agent.yml') || !oldData.docker
              " size="mini" type="primary" @click="copy(row)">复制
              </el-button>
              <el-button v-if="row.oldVersion != row.newVersion
                || row.name.toLowerCase().startsWith('exchange.xml')
                || row.name.toLowerCase().startsWith('servicehelper.yml')
                || row.name.toLowerCase().startsWith('service-agent.yml')
                || row.name.toLowerCase().trim().endsWith('-env')
                || row.name.toLowerCase().trim().endsWith('.service')
                || row.name.toLowerCase().trim().endsWith('.properties')" size="mini" type="primary"
                @click="deploy(row, index)">配置
              </el-button>
            </span>
          </span>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :title="fileName" :visible="xmlDialogVisible" width="75%" center v-if="xmlDialogVisible" append-to-body
      @close="xmlDialogVisible = false">

      <div v-if="totalChange != 0" style="font-size: 20px;color: #ff3538;">共有{{ totalChange }}处不同
        <el-button type="primary" size="mini" style="margin-left: 10px" @click="nextDiff">下一处</el-button>
      </div>
      <span style="font-size: 18px">新配置文件：</span>
      <span style="font-size: 18px;margin-left: 400px">原配置文件：</span>
      <el-button type="primary" size="mini" v-if="!anothercode" style="margin-left: 200px"
        @click="configDetailRemote()">从远端获取
      </el-button>
      <el-button type="primary" size="mini" v-if="anothercode && !isConfigDetailLoaded"  style="margin-left: 200px"
        @click="saveFileToLocal()">保存到本地
      </el-button>
      <div id="view" style="margin-top: 5px">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFile()">保 存</el-button>
        <el-button type="primary" @click="xmlDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import CodeMirror from 'codemirror'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/yaml-lint'
import 'codemirror/addon/lint/json-lint'
// 代码折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/xml-fold.js'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
//代码版本差异比较
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import DiffMatchPatch from 'diff-match-patch'

window.diff_match_patch = DiffMatchPatch;
window.DIFF_DELETE = -1;
window.DIFF_INSERT = 1;
window.DIFF_EQUAL = 0;

export default {
  props: {
    oldData: {
      type: Object
    },
    newData: {
      type: Object
    }
  },
  data: vm => ({
    oldItem: {
      configList: []
    },
    newItem: {
      configList: []
    },
    xmlDialogVisible: false,
    showBack: false,
    fileName: '',
    yamlEditor: {},
    xmlContent: '',
    textContent: '',
    saveLocation: "",
    nowCode: "",
    anothercode: "",
    OldLocation: "",
    configrowids: [],
    cids: [],
    configName: "",
    yamlleftEditor: null,
    totalChange: null,
    locationList: [],
    allLocation: '',
    totalDiff: 0,
    isConfigDetailLoaded:false
  }),
  created() {
    // this.profileUpgrade();
    // 获取配置文件列表
    // this.getConfigs(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem')
    // this.getConfigs(this.newData.moduleType, this.newData.moduleVersion, 'newItem')
  },
  // mounted(){
  //   this.profileUpgrade();
  // },
  watch: {
    xmlContent(value) {
      const editorValue = this.yamlEditor.getValue();
      if (value !== editorValue) {
        this.yamlEditor.setValue(this.xmlContent)
      }
    },
    yamlleftEditor: {
      handler() {
        this.totalChange = this.yamlleftEditor.right.chunks.length;
      },
      deep: true
    }
  },
  computed: {
    configList() {
      let _this = this;
      let arr = [];
      if (!this.oldData.docker) {
        if (this.oldItem.configList.length == 0 || this.newItem.configList.length == 0) {
          return
        }
      } else {
        if (this.oldItem.configList.length == 0) {
          return
        }
      }
      let obj = {};
      this.oldItem.configList.forEach((oldConfig, i) => {
        // const sameItems = this.newItem.configList.filter(newConfig => newConfig.name == oldConfig.name)
        const index = _this.newItem.configList.findIndex(newConfig => newConfig.name == oldConfig.name && newConfig.location == oldConfig.location)

        if (index != -1) {
          obj = {
            // status:_this.newItem.configList[index].status,
            name: oldConfig.name,
            oldVersion: oldConfig.version,
            isDir: oldConfig.isDir,
            newVersion: _this.newItem.configList[index].version,
            // location: oldConfig.location,
            oldLocation: oldConfig.location+"",
            newLocation: _this.newItem.configList[index].location+"",
            creator: oldConfig.creator,
            // id: oldConfig.id
          };
          if (oldConfig.version == _this.newItem.configList[index].version) {
            // obj.passed = true
            obj.passed = false
          }
          _this.newItem.configList[index].hasChecked = true;
          oldConfig.hasChecked = true;
          arr.push(obj)
        }
      });

      let oldDataUnChecked = this.oldItem.configList.filter(ocon => !ocon.hasChecked);
      let newDataUnChecked = this.newItem.configList.filter(ncon => !ncon.hasChecked);
      if (oldDataUnChecked.length > 0) {
        // arr = arr.concat(oldDataUnChecked)
        oldDataUnChecked.forEach(odata => {
          arr.push({
            name: odata.name,
            oldVersion: odata.version,
            newVersion: '',
            oldLocation: odata.location+"",
            passed: false,
            hasChecked: true,
            creator: odata.creator,
            // id: odata.id
          })
        })
      }
      if (newDataUnChecked.length > 0) {
        // arr = arr.concat(newDataUnChecked)
        newDataUnChecked.forEach(ndata => {
          arr.push({
            name: ndata.name,
            oldVersion: '',
            newVersion: ndata.version,
            newLocation: ndata.location+"",
            passed: false,
            hasChecked: true,
            creator: ndata.creator,
            // id: ndata.id
          })
        })
      }
      let that = this;
      if (that.cids && that.cids.length > 0) {
        arr.forEach(e => {
          if (that.cids.indexOf(e.name) > -1) {
            e.passed = true;
          }
        })
      }
      return arr
    },
  },
  methods: {
    nextDiff() {
      if (this.yamlleftEditor.right.chunks.length > 0) {
        let t = this.yamlleftEditor.edit.charCoords({ line: this.yamlleftEditor.right.chunks[this.totalDiff].editTo, ch: 0 }, "local").top;
        let middleHeight = this.yamlleftEditor.edit.getScrollerElement().offsetHeight / 2;
        this.yamlleftEditor.edit.scrollTo(null, t - middleHeight - 5);
        this.totalDiff += 1;
        if (this.totalDiff == this.yamlleftEditor.right.chunks.length) {
          this.$message.error("已经到底了哦!");
          this.totalDiff = 0;
        }
      }
    },
    profileUpgrade() {
      if (this.oldData.docker == true) {
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem');
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'newItem');
      } else {
        this.getConfigs(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem');
        this.getConfigs(this.newData.moduleType, this.newData.moduleVersion, 'newItem')
      }
    },
    initUI(value, orig) {
      if (value == null) return;
      let target = document.getElementById("view");
      target.innerHTML = "";
      let that = this;
      this.yamlleftEditor = CodeMirror.MergeView(target, {
        value: this.nowCode,//上次内容
        origLeft: null,
        orig: this.anothercode,//本次内容
        lineNumbers: true,//显示行号
        mode: "shell",
        highlightDifferences: true,
        styleActiveLine: true,
        matchBrackets: true,
        connect: 'align',
        readOnly: false,//是否只读
      });

      this.yamlleftEditor.edit.doc.setValue(this.nowCode);
      // this.yamlleftEditor.editor().on("change", function(cm, change) {
      // });
      let readOnlyLines = "ServiceID";
      this.yamlleftEditor.editor().on('beforeChange', function (cm, change) {

        let valueArray = [];
        if (change.text && change.text.length > 0) {
          change.text.forEach(e => {
            if (e.indexOf(readOnlyLines) > -1) {
              //let serviceValueStr = e.split(":")
              let othere = readOnlyLines + ": " + that.newData.serviceId;
              valueArray.push(othere)
            } else {
              valueArray.push(e)
            }
          })
        }
        change.text = valueArray;
      });
    },
    saveFile() {
      let path;
      if (this.oldData.docker) {
        path = this.allLocation;
      } else {
        path = this.saveLocation
      }
      let data = {
        moduleName: this.newData.moduleType,
        moduleVersion: this.newData.moduleVersion,
        instanceId: this.newData.id,
        configName: this.fileName,
        location: path+"",
        content: this.yamlleftEditor.edit.doc.getValue(),
      };
      let that = this;
      this.$axios.post(this.baseUrl3 + 'management3/config/update', data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.xmlDialogVisible = false;
            let _configName = that.configName;
            that.cids.push(_configName)
          } else {
            this.$message({ showClose: true, message: msg, type: 'error' });
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveFileToLocal(){
      let path;
      if (this.oldData.docker) {
        path = this.allLocation;
      } else {
        path = this.saveLocation
      }
      let data = {
        moduleName: this.oldData.moduleType,
        moduleVersion: this.oldData.moduleVersion,
        instanceId: this.oldData.id,
        configName: this.fileName,
        location: path+"",
        content: this.yamlleftEditor.edit.doc.getValue(),
      };
      let that = this;
      this.$axios.post(this.baseUrl3 + 'management3/config/update', data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.xmlDialogVisible = true;
            let _configName = that.configName;
            that.cids.push(_configName)
            this.$message({ showClose: true, message: "保存成功", type: "success" });
          } else {
            this.$message({ showClose: true, message: msg, type: 'error' });
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })

    },
    enter(location) {
      this.showBack = true;
      let param = "";
      this.locationList.push(location);
      this.locationList.forEach(d => {
        param = param + d + '/'
      });
      let path;
      if (this.locationList.length == 1) {
        path = location
      } else if (this.locationList.length > 1) {
        path = param
      }
      this.allLocation = path;
      this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem');
      this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'newItem');
    },
    back() {
      if (this.locationList.length > 1) {
        this.locationList.pop();
        this.enter(this.locationList.pop(), false);
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem');
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'newItem');
      } else {
        this.showBack = false;
        this.locationList = [];
        this.allLocation = null;
        this.locationList.push("");
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'oldItem');
        this.getDockerConfigList(this.oldData.moduleType, this.oldData.moduleVersion, 'newItem');
      }
    },
    getDockerConfigList(moduleType, moduleVersion, oldOrNew) {
      if (!moduleType || !moduleVersion) {
        console.log('获取配置文件列表缺少参数');
        return
      }
      // this.baseUrl3 + "config/cat/all/" + this.oldData.id
      // let path=null;
      if (this.showBack) {
        this.allLocation = this.allLocation
      } else {
        this.allLocation = null
      }
      // let url = this.baseUrl3 + "config/cat/list/" + this.oldData.id + "/" + encodeURIComponent(encodeURIComponent(this.allLocation));

      let url = this.baseUrl3 + 'config/cat/list'
      let data = {
        instanceId: this.oldData.id,
        path: this.allLocation
      }
      this.$axios.post(url, data).then(({ data: { msg, data, code } }) => {
        if (code == 20000) {
          if (data) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
            });
            this[oldOrNew].configList = data;
          } else {
            this[oldOrNew].configList = [];
          }
          if (!this.showBack) {
            this.locationList = [];
          }
        } else {
          this.$message({ showClose: true, message: msg, type: "error" });
          console.log(msg);
        }
      }).catch(err => {
        console.log('获取配置文件请求失败')
      });
    },
    // 获取配置文件列表
    getConfigs(moduleType, moduleVersion, oldOrNew) {
      if (!moduleType || !moduleVersion) {
        console.log('获取配置文件列表缺少参数');
        return
      }
      this.$axios
        .get(this.moduleUrl + "config/get/listByNameAndVersion/" + moduleType + "/" + moduleVersion)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
            });
            this[oldOrNew].configList = data;
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        }).catch(err => {
          console.log('获取配置文件请求失败')
        });
    },
    initYaml() {
      setTimeout(() => {
        let _this = this;
        _this.yamlEditor = null;
        _this.yamlEditor = CodeMirror.fromTextArea(_this.$refs.textarea, {
          lineNumbers: true,  // 显示行号
          mode: 'text/x-yaml',  // 语法model
          // theme: 'monokai',  // 编辑器主题
          lint: true, //开启语法检查,
          foldGutter: true,
          lineWrapping: true,
          gutters: [
            'CodeMirror-lint-markers',
            'CodeMirror-foldgutter',
            'CodeMirror-linenumbers'
          ],  // 语法检查器
        });
        this.xmlContent = this.textContent;
        // this.yamlEditor.setValue("");
        this.yamlEditor.setSize('100%', '100%');//设置代码框的长宽
        this.yamlEditor.setValue(this.xmlContent);
        this.yamlEditor.on('change', (cm) => {
          this.$emit('changed', cm.getValue());
          this.$emit('input', cm.getValue());
        })
      }, 0);
    },
    //从远端获取配置文件
    configDetailRemote() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let path;
      if (this.oldData.docker) {
        path = this.allLocation;
      } else {
        path = this.OldLocation
      }
      const arg =
        this.oldData.moduleType + "/" +
        this.oldData.moduleVersion + "/" +
        this.fileName + "/" + encodeURIComponent(encodeURIComponent(path));

      let url = this.moduleUrl + "config/cat/" + arg;

      if (this.oldData.id) {
        this.configDetailRemotePost(path)
      } else {
        // let that = this;
        this.$axios.get(url)
          .then(({ data: { msg, data, code } }) => {
            if (code == 20000) {
              this.xmlDialogVisible = true;
              // if(this.fileName == 'ServiceHelper.yml'){
              //   let objCode = '';
              //   try{
              //     objCode = jsyaml.load(data);
              //     if(objCode.ServiceID){
              //       objCode.ServiceID = that.newData.serviceId;
              //     }
              //   }catch (e) {
              //     objCode = data
              //   }
              //   this.anothercode = jsyaml.safeDump(objCode);
              // }else {
              //   this.anothercode = data
              // }
              // let objCode = jsyaml.load(data);
              // if(objCode.ServiceID){
              //   objCode.ServiceID = that.newData.serviceId;
              // }
              this.anothercode = data;
              this.isConfigDetailLoaded = true
              // this.anothercode = jsyaml.safeDump(objCode);
              //this.anothercode = data;
              this.$nextTick(function () {
                this.initUI(this.nowCode, this.anothercode)
              });
            } else {
              this.$message({ showClose: true, message: msg, type: "error" });
              console.log(msg);
            }
            loading.close()
          }).catch(err => {
            loading.close();
            console.log(err)
          });
      }

    },
    configDetailRemotePost(path) {

      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      let url = this.baseUrl3 + 'config/cat/remote/content'
      //  + this.oldData.id + '/' + this.fileName + "/" + encodeURIComponent(encodeURIComponent(path));
      if (path == null) {
        path = 'null'
      }

      let data = {
        configName: this.fileName,
        instanceId: this.oldData.id,
        location: path+""
      }
      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.xmlDialogVisible = true;

            this.anothercode = data;

            this.$nextTick(function () {
              this.initUI(this.nowCode, this.anothercode)
            });
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
          loading.close();
          console.log(err)
        });
    },
    downloadConfig(row, operate) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      // baseUrl + 'config/download/'
      //                 + newData.moduleType + '/'
      //                 + newData.moduleVersion + '/'
      //                 + newData.id + '/'
      //                 + row.name.trim() + '/'
      //                 + encodeURIComponent(encodeURIComponent(row.newLocation))

      let url = this.baseUrl3 + 'config/local/download'
      let data = {}

      if (operate == 'new') {
        data = {
          moduleName: this.newData.moduleType,
          moduleVersion: this.newData.moduleVersion,
          instanceId: this.newData.id,
          configName: row.name.trim(),
          location: row.newLocation+""
        }
      }
      // "baseUrl + 'config/download/'
      //                 + oldData.moduleType + '/'
      //                 + oldData.moduleVersion + '/'
      //                 + oldData.id + '/'
      //                 + row.name.trim() + '/'
      //                 + encodeURIComponent(encodeURIComponent(row.oldLocation))"
      if (operate == 'old') {
        data = {
          moduleName: this.oldData.moduleType,
          moduleVersion: this.oldData.moduleVersion,
          instanceId: this.oldData.id,
          configName: row.name.trim(),
          location: row.oldLocation+""
        }
      }
      this.$axios.post(url, data, {
        responseType: 'blob' // 设置响应类型为blob
      })
        .then(function (response) {
          // 创建一个Blob对象
          const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据文件类型设置MIME类型
          // 创建一个下载链接
          const url = window.URL.createObjectURL(blob);
          // 创建一个a标签并设置属性以开始下载
          const a = document.createElement('a');
          a.href = url;

          // content-disposition必须为小写
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'default_filename'; // 默认文件名
          if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches && matches.length > 1) {
              filename = matches[1];
            }
          }
          a.download = filename; // 设置下载文件的名称
          // 将a标签添加到DOM中并模拟点击以开始下载
          document.body.appendChild(a);
          a.click();
          // 清理DOM
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error); // 处理错误情况
        });


    },
    compare(row) {
      this.xmlDialogVisible = true;
      this.configNewDetail(row);
      this.configOldDetail(row);
    },
    configNewDetail(row) {
      this.configName = row.name.trim();
      let that = this;
      let path;
      if (this.oldData.docker) {
        path = this.allLocation;
      } else {
        path = row.newLocation
      }
      // let url = this.baseUrl + 'config/cat/' + this.newData.moduleType + '/'
      //   + this.newData.moduleVersion + '/'
      //   + this.newData.id + '/'
      //   + row.name.trim() + '/' + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + 'config/cat/content'
      let data = {
        moduleName: this.newData.moduleType,
        moduleVersion: this.newData.moduleVersion,
        instanceId: this.newData.id,
        configName: row.name.trim(),
        location: path+""
      }

      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.xmlDialogVisible = true;
            this.fileName = row.name.trim();
            this.saveLocation = row.newLocation;
            if (this.fileName == 'ServiceHelper.yml') {
              let objCode = '';
              try {
                objCode = jsyaml.load(data);
                if (objCode.ServiceID != undefined) {
                  objCode.ServiceID = that.newData.serviceId;
                }
              } catch (e) {
                objCode = data
              }
              this.nowCode = jsyaml.safeDump(objCode);

            } else {
              this.nowCode = data
            }
            this.$nextTick(function () {
              this.initUI(this.nowCode, this.anothercode)
            });
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err)
        });
    },
    configOldDetail(row) {
      let path;
      if (this.oldData.docker) {
        path = this.allLocation;
      } else {
        path = row.oldLocation
      }
      // let url = this.baseUrl + 'config/cat/' + this.oldData.moduleType + '/'
      //   + this.oldData.moduleVersion + '/'
      //   + this.oldData.id + '/'
      //   + row.name.trim() + '/' + encodeURIComponent(encodeURIComponent(path));

      let url = this.baseUrl3 + 'config/cat/content'
      let data = {
        moduleName: this.oldData.moduleType,
        moduleVersion: this.oldData.moduleVersion,
        instanceId: this.oldData.id,
        configName: row.name.trim(),
        location: path+""
      }

      this.OldLocation = row.oldLocation;
      this.anothercode = "";
      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.xmlDialogVisible = true;
            this.fileName = row.name.trim();
            if (data) {
              this.anothercode = data;
            }

            this.$nextTick(function () {
              this.initUI(this.nowCode, this.anothercode)
            });
          } else {
            this.$message({ showClose: true, message: "本地配置文件不存在！可从远端获取！", type: "error" });
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err)
        });
    },
    // type: old原文件， new新文件
    // configDetail(row, type) {
    //   let url = this.baseUrl + 'config/cat/' + this[type + 'Data'].moduleType + '/'
    //     + this[type + 'Data'].moduleVersion + '/'
    //     + this[type + 'Data'].id + '/'
    //     + row.name.trim() + '/' + encodeURIComponent(row[type + 'Location']);
    //   this.saveType = type;
    //   this.$axios.get(url)
    //     .then(({data: {msg, data, code}}) => {
    //       if (code == 20000) {
    //         this.xmlDialogVisible = true;
    //         this.fileName = row.name;
    //         // this.xmlContent = data;
    //         this.initYaml();
    //         this.textContent = "";
    //         this.textContent = data;
    //       } else {
    //         if (type == "old") {
    //           this.$confirm('本地内容为空，是否从远端获取数据?', '提示', {
    //             confirmButtonText: '确定',
    //             cancelButtonText: '取消',
    //             type: 'warning'
    //           }).then(() => {
    //             this.configDetailRemote(row);
    //           }).catch(() => {
    //             this.$message({
    //               type: 'info',
    //               message: '已取消'
    //             });
    //           });
    //         }
    //         // this.$message({showClose: true, message: msg, type: "error"});
    //         // console.log(msg);
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     });
    // },


    // 复制
    copy(row) {
      // 实例配置文件操作, 两个实例指定配置文件复制接口 config/copy
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      // this.baseUrl + "config/copy/" + this.oldData.moduleType + '/' +
      //     this.oldData.id + '/' + this.oldData.moduleVersion + '/' +
      //     this.newData.id + '/' + this.newData.moduleVersion + '/' + row.name.trim() + '/' +
      //     encodeURIComponent(encodeURIComponent(row.oldLocation))
      let url = this.baseUrl3 + 'config/copy'
      let data = {
        moduleName: this.oldData.moduleType,
        srcInstanceId: this.oldData.id,
        dstInstanceId: this.newData.id,
        srcModuleVersion: this.oldData.moduleVersion,
        dstModuleVersion: this.newData.moduleVersion,
        configName: row.name.trim(),
        location: row.oldLocation+""
      }

      this.$axios
        .post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功');
            row.passed = true;
            row.name = row.name + ' ';// 触发页面更新
            this.cids.push(row.name.trim())
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close()
        })
        .catch(err => {
          console.log(err);
          loading.close()
        });
    },
    deploy(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let that = this;

      let url = this.baseUrl3 + "instance/allocateOf"
      // this.newData.id + '/' +
      // row.name.trim() + '/' +
      // row.newVersion + '/' +
      // encodeURIComponent(encodeURIComponent(row.newLocation))
      let data = {
        instanceId: this.newData.id,
        configName: row.name.trim(),
        configVersion: row.newVersion,
        location: row.newLocation+""
      }
      this.$axios
        .post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功');
            row.passed = true;
            row.name = row.name + ' '// 触发页面更新
            let _configName = row.name.trim();
            that.cids.push(_configName);
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close()
        })
        .catch(err => {
          console.log(err);
          loading.close()
        });
    },
    handleSuccess({ code, msg, data }, file, fileList) {
      if (code == 20000) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败！原因：" + msg);
      }
    },
    handleError(err, file, fileList) {
      this.$message({ showClose: true, message: "上传失败", type: "error" });
      console.log("error=" + err);
    },
  }
}
</script>
<style scoped>
#view {
  font-size: 20px;
  line-height: 150%;
}

textarea {
  border: none;
  outline: none;
  box-shadow: none;
  resize: none;
}
</style>
